import { SpyneTrait, ChannelPayloadFilter } from 'spyne';

export class ChannelFullscreenTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = 'channelFullscreen$';
    super(context, traitPrefix);
  }

  static channelFullscreen$OnRegistered() {
    const toggleFilter = new ChannelPayloadFilter({
      eventType: 'fullscreen',
      action: 'CHANNEL_UI_CLICK_EVENT',
    });

    this.getChannel('CHANNEL_UI', toggleFilter).subscribe(
      this.channelFullscreen$OnToggleClick.bind(this),
    );
  }

  // The click only asks; FullscreenNullView talks to the browser.
  static channelFullscreen$OnToggleClick() {
    const action =
      this.props.isFullscreen === true
        ? 'CHANNEL_FULLSCREEN_EXIT_EVENT'
        : 'CHANNEL_FULLSCREEN_ENTER_EVENT';

    this.sendChannelPayload(action, { isFullscreen: this.props.isFullscreen });
  }

  // State moves only when the browser confirms it — the toggle, Esc, or a
  // refused request all arrive here — and CHANGE announces the result.
  static channelFullscreen$OnStateRequest(e) {
    const isFullscreen = e?.payload?.isFullscreen === true;
    this.props.isFullscreen = isFullscreen;
    this.sendChannelPayload('CHANNEL_FULLSCREEN_CHANGE_EVENT', { isFullscreen });
  }
}
